import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComPromoterCategoryModel } from 'src/app/model/com-promoter-category.model';

@Injectable({
  providedIn: 'root'
})
export class ComPromoterCategoryService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/CommissionPromoterCategory/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  save=(commission:ComPromoterCategoryModel)=> {
    console.log(JSON.stringify(commission));
    return this.http.post(`${this.url}/CommissionPromoterCategory/SaveUpdate`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComPromoterCategoryModel[])=> {
    return this.http.post(`${this.url}/CommissionPromoterCategory/saveAll`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComPromoterCategoryModel)=> {
    return this.http.post(`${this.url}/CommissionPromoterCategory/SaveUpdate/${commission.commissionPromoterCategoryId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
